

import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


export const getSelfCareCampaignStatus = async (userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/selfcare-campaign/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching self care campaign status:", error);
        throw error.response?.data || { success: false, message: "Something went wrong" };
    }
};

export const saveSelfCareCampaign = async (data) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/selfcare-campaign`,
            data
        );
        return response.data;
    } catch (error) {
        console.error("Error saving self care campaign:", error);

        throw (
            error.response?.data || {
                success: false,
                message: "Something went wrong",
            }
        );
    }
};